module.exports = __webpack_public_path__ + "static/media/logo133.e048642c.png";